import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Observable, defer } from 'rxjs';
import { startWith } from 'rxjs/operators';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fromControl<T>(control: FormControl<T> | FormGroup<{ [K in keyof T]: AbstractControl<any> }>): Observable<T> {
  if ((control as FormGroup)?.controls) {
    const formGroup = control as FormGroup;
    return defer(() => formGroup.valueChanges.pipe(startWith(formGroup.getRawValue())));
  } else {
    const formControl = control as FormControl<T>;
    return defer(() => formControl.valueChanges.pipe(startWith(formControl.getRawValue())));
  }
}
